import { styled } from '@mui/material';
import { SnackbarContent } from 'notistack';

export const SnackMessageWrapper = styled(SnackbarContent)(({ theme }) => ({
  [theme.breakpoints.up('sm')]: {
    width: theme.breakpoints.values.sm * 0.8,
  },
}));
